<template>
  <div class="container-fluid">

    <div class="container-fluid bg-base-green trees-bg">
      
      <div class="row pt-3">
        <div class="col-12">
          <div  class="titular-uno">
            <p>{{$t('titulo')}}</p>
          </div>
        </div>
      </div>
        
      <div class="row regentes-icons pb-5">
        <div class="col-3 col-md-3 intro">                 
          
          <div class="icon-label">
            <router-link :to="{ name: 'Plataforma' }"><div class="circle plataforma-icon mb-3" rounded="circle"></div>
              <span>{{$t('about')}}</span>
            </router-link>
          </div>
        </div>
        <div class="col-3 col-md-3 intro">                 
          
          <div class="icon-label">
            <router-link :to="{ name: 'Planes' }"><div class="circle pmf-icon mb-3" rounded="circle"></div>
              <span>{{$t('pmf')}}</span>
            </router-link>
          </div>
        </div>
        <div class="col-3 col-md-3 intro">            
          <div class="icon-label">
            <router-link :to="{ name: 'Involucrados' }"><div class="circle involucrado-icon mb-3" rounded="circle"></div>
              <span>{{$t('actores_inv')}}</span>
            </router-link>
          </div>
        </div> 
        <div class="col-3 col-md-3 intro">          
          <div class="icon-label">
            <router-link :to="{ name: 'MapaPage' }"><div class="circle mapa-icon mb-3" rounded="circle"></div>
              <span>{{$t('mapa_int')}}</span>
            </router-link>
          </div>
        </div>
      </div>   
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center mb-3">
            <div class="col-12 col-md-5">
              <div class="instructivo mt-3 mb-3" v-html="$t('observatorio_instructivo')"></div>             
            </div>
          </div> 
    </div>

    <div class="container-fluid bg-summary">
      <div class="container">
        <div class="row featured-block pt-3">
          <div class="col-12">
            <p class="subtitular-uno">{{$t('sub_titulo_1')}}</p>
            <p class="subtitular-uno">{{$t('sub_titulo_2')}}</p>
            <p class="subtitular-uno">{{$t('sub_titulo_3')}}</p>
          </div>
        </div>    
        
        <div class="row featured-block pt-3 pb-5">
          <div class="col-6 col-md-3">
            <div class="featured">
              <h4><ICountUp :delay="500" :endVal="consultor_pmf"/></h4>
              <label>{{$t('consultores_regentes')}}</label>
            </div>          
          </div>
          <div class="col-6 col-md-3">
            <div class="featured">
              <h4><ICountUp :delay="500" :endVal="profesional_inf_tecnico_insp_ocular"/></h4>
              <label>{{$t('profesional_tecnico')}}</label>
            </div>          
          </div>
          <div class="col-6 col-md-3">
            <div class="featured">
              <h4><ICountUp :delay="500" :endVal="profesional_recomienda_aprueba_pmf"/></h4>
              <label>{{$t('profesional_recomienda')}}</label>
            </div>          
          </div>
          <div class="col-6 col-md-3">
            <div class="featured">
              <h4><ICountUp :delay="500" :endVal="funcionario_aprobo_pmf"/></h4>
              <label>{{$t('profesional_aprobaron')}}</label>
            </div>          
          </div>
        </div>

        <div class="row featured-block pt-3 pb-5">    
          
          <div class="col-6 col-md-4">
            <div class="featured">
              <h4>{{ arboles_aprobados | numFormat }}</h4>
              <label>{{$t('arboles_aprob')}}</label>
            </div>          
          </div>        
          <div class="col-6 col-md-4">
            <div class="featured">
              <h4>{{ mues_supervisado_pmf | numFormat }}</h4>
              <label>{{$t('arboles_sup')}}</label>
            </div>          
          </div>
          <div class="col-6 col-md-4"> 
            <div class="featured">            
              <h4>{{ vol_porcentaje }}% ({{ inexistentes | numFormat }})</h4>
              <label>{{$t('arboles_inex')}}</label>
            </div>          
          </div>
          <div class="col-6 col-md-4 mt-3">
            <div class="featured">
              <h4>{{ vol_aprobado.toFixed(2)| numFormat}} <span class="medida ml-">m3</span></h4>
              <label>{{$t('vol_aprob')}}</label>
            </div>          
          </div>        
          <div class="col-6 col-md-4 mt-3">
            <div class="featured">
              <h4>{{ vol_suma.toFixed(2) | numFormat }} <span class="medida ml-">m3</span></h4>
              <label>{{$t('vol_sup')}}</label>
            </div>          
          </div>
          <div class="col-6 col-md-4 mt-3">
            <div class="featured">
              <h4>{{ vol_injustificado_percent | numFormat }} % ({{ vol_injustificado | numFormat }})</h4>
              <label>{{$t('vol_inju')}}</label>
            </div>          
          </div>

        </div>     
      </div>
      
    </div>

    <div class="container-fluid bg-gray">
      <Buscador :dataset="buscador"></Buscador>
    </div>

    <div class="container pt-5 pb-5">

      <div class="row">
        <div class="col-12 mb-5">
          <aniosGraph :dataset="dataset"></aniosGraph>
        </div>
      </div>


      <div class="row border-top pt-5">
        <div class="col-12">
          <div class="ranking">
            <h3>{{$t('ranking')}}</h3>
          </div>
        </div>
      </div>   

      <div class="row pb-5">
        <div class="col-12">
          <RankingRegentes :dataset="dataset"></RankingRegentes>
        </div>
      </div>

      <div class="row pb-5">
        <div class="col-12">
          <div class="btn-graph ml-3 text-center">
            <router-link class="btn btn-planes" :to="{ name: 'Involucrados' }">
              <span>{{$t('explo_actores')}}</span>
            </router-link>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <span>{{$t('info')}}</span>

        </div>

      </div>

    </div>    
  
  </div>

</template>

<script>
  
  import aniosGraph from '../components/aniosGraph.vue'
  import Buscador from '../components/Buscador.vue'  
  import RankingRegentes from '../components/RankingRegentes.vue'
  import { filter, map, sum, uniq } from 'lodash'
  import ICountUp from 'vue-countup-v2'
  

  export default {
    name: 'Home',
    props: {
      dataset: Array
    },
    components: {
      aniosGraph,    
      Buscador,
      RankingRegentes,
      ICountUp
    },
    
    computed: {
      buscador() {
        return this.dataset
      },
      mues_supervisado_pmf(){
        return sum(map(filter(this.dataset, item=> item.mues_supervisado_pmf != 'ND'), 'mues_supervisado_pmf'))
      },
      vol_aprobado(){
        return sum(map(filter(this.dataset, item=> item.vol_aprobado != 'ND'), 'vol_aprobado'))
      },
      arboles_aprobados() {
        return sum(map(filter(this.dataset, item=> item.arboles_aprobados != 'ND'), 'arboles_aprobados'))
      },
      vol_movilizado() {
        return sum(map(filter(this.dataset, item=> item.vol_movilizado != 'ND'), 'vol_movilizado'))
      },
      especies_aprobadas() {
        return sum(map(filter(this.dataset, item=> item.cant_especies_aprobada != 'ND'), 'cant_especies_aprobada'))
      },
      inexistentes() {
        return sum(map(filter(this.dataset, item=> item.individuos_inexistentes != 'ND'), 'individuos_inexistentes'))
      },
      vol_injustificado() {
        return sum(map(filter(this.dataset, item=> item.vol_injustificado != 'ND'), 'vol_injustificado'))
      },
      funcionario_aprobo_pmf() {
        return uniq(map(filter(this.dataset, item=> item.funcionario_aprobo_pmf != 'ND'), 'funcionario_aprobo_pmf')).length
      },
      profesional_recomienda_aprueba_pmf() {
        return uniq(map(filter(this.dataset, item=> item.profesional_recomienda_aprueba_pmf != 'ND'), 'profesional_recomienda_aprueba_pmf')).length
      },
      consultor_pmf() {
        return uniq(map(filter(this.dataset, item=> item.consultor_pmf != 'ND'), 'consultor_pmf')).length
      },
      profesional_inf_tecnico_insp_ocular() {
        return uniq(map(filter(this.dataset, item=> item.profesional_inf_tecnico_insp_ocular != 'ND'), 'profesional_inf_tecnico_insp_ocular')).length
      },
      vol_justificado() {
        return sum(map(filter(this.dataset, item=> item.vol_justificado != 'ND'), 'vol_justificado'))
      },
      vol_porcentaje() {
        return ((this.inexistentes/this.mues_supervisado_pmf)*100).toFixed(1)
      },
      vol_suma() {
        return(this.vol_justificado+this.vol_injustificado)
      },
      vol_injustificado_percent() {
        return ((this.vol_injustificado/this.vol_suma)*100).toFixed(1)

      }
    }
  }
  
</script>
